var s_min = 640;
var m_min = 1024;
var l_min = 1441;
var xl_min = 1920;

jQuery.fn.cleanWhitespace = function () {
  this.contents()
    .filter(function () {
      return this.nodeType == 3 && !/\S/.test(this.nodeValue);
    })
    .remove();
  return this;
};

$(document).ready(function () {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", vh + "px");

  objectFitImages();

  var lazy_elements = ".lazy";

  if ($(window).width() <= s_min) {
    lazy_elements =
      ".lazy, .articles-slideshow .swiper-lazy, .shop-slideshow .swiper-lazy";
  }

  var lazy_load = new LazyLoad({
    elements_selector: lazy_elements,
    threshold: $(window).height() * 3,
  });

  var translate_ticket_val = 0;
  var ticker_interval = false;
  var ticker_timeout = false;

  if ($(".ticker").length) {
    start_ticker();
  }

  //HOMEPAGE HERO TICKER
  function start_ticker() {
    var ticker = $(".ticker");
    var ticker_items = ticker.find(".ticker-item");
    var ticker_group = ticker.find(".ticker-group");

    var ticker_group_width =
      ticker_group.width() + (ticker_items.length * 50 + 54);
    var time = 10 * ticker_items.length;

    if (!ticker.hasClass("has-started")) {
      ticker_items.clone().appendTo(ticker_group);
      ticker_group.cleanWhitespace();
    }

    ticker.addClass("has-started");

    ticker.mouseleave(function () {
      if (ticker_interval == false) {
        start_ticker();
      }
    });

    ticker.mouseenter(function () {
      clearInterval(ticker_interval);
      ticker_interval = false;
    });

    $(".ticker-item").mouseenter(function () {
      var element = $(this);

      $(".ticker-item").addClass("faded");
      element.removeClass("faded");
    });

    $(".ticker-item").mouseleave(function () {
      $(".ticker-item").removeClass("faded");
    });

    ticker_interval = setInterval(function () {
      if (translate_ticket_val >= ticker_group_width) {
        translate_ticket_val = 0;
      }

      translate_ticket_val++;
      ticker_group.css({
        transform: "translateX(-" + translate_ticket_val + "px)",
      });
    }, 15);
  }

  //SEARCH
  var topics = $("#all-topics").text();
  topics = topics.split(",");
  topics = topics.filter(function (e) {
    return e;
  });

  $("#search-input, #search-input-mobile")
    .autocomplete({
      source: [topics],
      valid: function (value, query) {
        // return value.toLowerCase().indexOf(query.toLowerCase())!=-1;
        return value.toLowerCase().match("^" + query.toLowerCase());
      },
    })
    .on("pick.xdsoft", function (e, data) {
      if (data) {
        ajax_search(data.toLowerCase(), "");
      }
    });

  $("#search-input, #search-input-mobile").keyup(function (e) {
    var element = $(this);
    var string = element.val();

    var suggestion = $(".xdsoft_autocomplete_hint").val();

    if (e.keyCode != 37 && e.keyCode != 38 && e.keyCode != 39) {
      ajax_search(suggestion, string);
    }

    if (e.keyCode == 13) {
      element.parents("form").submit();
    }
  });

  var search_timeout;
  function ajax_search(suggestion, string) {
    clearTimeout(search_timeout);

    search_timeout = setTimeout(function () {
      if (suggestion) {
        $.ajax({
          type: "POST",
          url: atmos.adminAjax,
          data: {
            action: "CCAjax",
            request: "get_ajax_results",
            suggestion: suggestion,
          },
          timeout: 1000000,
          beforeSend: function () {},
          success: function (result) {
            $(".ajax-results").empty();
            $(".ajax-results").append(result);
            lazy_load.update();
          },
          error: function () {},
        });
      } else if (string && string.length >= 3) {
        $.ajax({
          type: "POST",
          url: atmos.adminAjax,
          data: {
            action: "CCAjax",
            request: "get_ajax_results",
            string: string,
          },
          timeout: 1000000,
          beforeSend: function () {},
          success: function (result) {
            $(".ajax-results").empty();
            $(".ajax-results").append(result);
            lazy_load.update();
          },
          error: function () {},
        });
      } else {
        $(".ajax-results").empty();
      }
    }, 500);
  }

  //DRAWERS
  var menu_drawer = $(".drawer-menu");
  var search_drawer = $(".drawer-search");
  var shopping_bag_drawer = $(".drawer-shopping-bag");

  var last_scroll_position;
  $(".toggle-drawer").click(function () {
    $(".toggle-drawer").removeClass("expanded");
    $(this).addClass("expanded");
    last_scroll_position = $("html, body").scrollTop();

    menu_drawer.removeClass("open");
    search_drawer.removeClass("open");
    shopping_bag_drawer.removeClass("open");

    var drawer = $(this).attr("data-drawer");

    setTimeout(function () {
      $("html").addClass("overflow-hidden");
    }, 400);

    // site_header.removeClass('home-style-active');
    site_header.addClass("drawer-open");
    site_header.attr("drawer-open", drawer);

    if (drawer == "menu") {
      menu_drawer.addClass("open");
    } else if (drawer == "search") {
      search_drawer.addClass("open");
      $("#search-input").focus();

      if ($(window).width() <= m_min) {
        $("#search-input-mobile").focus();
      }
    } else if (drawer == "shopping-bag") {
      shopping_bag_drawer.addClass("open");
    }

    return false;
  });

  function reset_features_menu() {
    var featuresItem = menu_drawer.find(".drawer-menu__item--features");
    var toggle = featuresItem.find(".drawer-menu__toggle");
    var topics = featuresItem.find(".drawer-menu__topics");

    featuresItem.removeClass("drawer-menu__item--open");
    toggle.attr("aria-expanded", "false");
    topics
      .attr("aria-hidden", "true")
      .removeClass("drawer-menu__topics--visible")
      .css({ height: "", display: "none" })
      .off("transitionend.drawerTopics");
    menu_drawer.removeClass("featured-expanded");
  }

  function reset_magazine_drawer() {
    menu_drawer.find(".main").addClass("expanded");
    menu_drawer.find(".magazine").removeClass("expanded");
  }

  function expand_topics(topics) {
    if (!topics.length) return;

    topics.off("transitionend.drawerTopics");
    topics.attr("aria-hidden", "false");
    topics.css({ display: "block", height: 0 });

    var targetHeight = topics.get(0).scrollHeight;
    topics.get(0).offsetHeight;

    topics.addClass("drawer-menu__topics--visible");
    topics.css("height", targetHeight);
    menu_drawer.addClass("featured-expanded");

    topics.one("transitionend.drawerTopics", function (event) {
      if (
        event.originalEvent &&
        event.originalEvent.propertyName !== "height"
      ) {
        return;
      }
      topics.css("height", "auto");
    });
  }

  function collapse_topics(topics) {
    if (!topics.length) return;

    topics.off("transitionend.drawerTopics");

    var currentHeight = topics.outerHeight();
    topics.css("height", currentHeight);
    topics.get(0).offsetHeight;

    topics.removeClass("drawer-menu__topics--visible");
    topics.css("height", 0);
    topics.attr("aria-hidden", "true");

    topics.one("transitionend.drawerTopics", function (event) {
      if (
        event.originalEvent &&
        event.originalEvent.propertyName !== "height"
      ) {
        return;
      }
      topics.css({ height: "", display: "none" });
    });

    menu_drawer.removeClass("featured-expanded");
  }

  function close_drawer() {
    $("html, body").removeClass("js-drawer-open");
    $("html").removeClass("overflow-hidden");
    $("html, body").scrollTop(last_scroll_position);

    $(".toggle-drawer").removeClass("expanded");

    site_header.removeClass("drawer-open");
    site_header.attr("drawer-open", "");

    menu_drawer.removeClass("open");
    search_drawer.removeClass("open");
    shopping_bag_drawer.removeClass("open");

    reset_features_menu();
    reset_magazine_drawer();
  }

  $(document).click(function (e) {
    var target = $(e.target);

    if (
      site_header.hasClass("drawer-open") &&
      !target.is(menu_drawer) &&
      !target.is(".drawer-menu *") &&
      !target.is(search_drawer) &&
      !target.is(".drawer-search *") &&
      !target.is(shopping_bag_drawer) &&
      !target.is(".drawer-shopping-bag *")
    ) {
      close_drawer();
    }
  });

  $(".close-drawer").click(function () {
    close_drawer();

    return false;
  });

  //MENU DRAWER
  menu_drawer.find(".open-magazine").click(function () {
    menu_drawer.find(".main").removeClass("expanded");
    menu_drawer.find(".magazine").addClass("expanded");

    var menu_volumes = $(".menu-volumes-slideshow")[0];
    if (menu_volumes && menu_volumes.swiper) {
      menu_volumes.swiper.update();
    }

    return false;
  });

  menu_drawer.find(".close-magazine").click(function () {
    menu_drawer.find(".main").addClass("expanded");
    menu_drawer.find(".magazine").removeClass("expanded");

    return false;
  });

  menu_drawer.find(".drawer-menu__toggle").click(function (event) {
    event.preventDefault();

    var toggle = $(this);
    var parent = toggle.closest(".drawer-menu__item");
    var topics = parent.find(".drawer-menu__topics");
    var isOpen = parent.hasClass("drawer-menu__item--open");

    if (isOpen) {
      parent.removeClass("drawer-menu__item--open");
      toggle.attr("aria-expanded", "false");
      collapse_topics(topics);
    } else {
      parent.addClass("drawer-menu__item--open");
      toggle.attr("aria-expanded", "true");
      expand_topics(topics);
    }

    return false;
  });

  //DISCOVER DRAWER SCROLL BEHAVIOUR
  $(".letters-list .letter").click(function () {
    var letters_list = discover_drawer.find(".letters-list");

    var letter = $(this).attr("data-letter");
    var offset = $('.letter-group[data-letter="' + letter + '"]').attr(
      "data-offset"
    );

    var extra_offset = 160;

    if ($(window).width() <= m_min) {
      extra_offset = 190;
    } else if ($(window).width() <= s_min) {
      extra_offset = 195;
    }

    discover_drawer.animate(
      {
        scrollTop: offset - extra_offset,
      },
      600
    );

    return false;
  });

  //PLAYERS
  $(".player, iframe").each(function () {
    var element = $(this);
    var player = new Plyr(element, {
      controls: [
        "play-large",
        "play",
        "progress",
        "captions",
        "mute",
        "fullscreen" /*'settings'*/,
      ],
      // settings: ['captions'],
      clickToPlay: true,
      captions: { active: false, language: "auto", update: true },
      youtube: {
        noCookie: false,
        rel: 0,
        showinfo: 0,
        cc_load_policy: 3,
        modestbranding: 1,
        controls: 0,
        enablejsapi: true,
        playsinline: false,
      },
      vimeo: { playsinline: false, controls: 0 },
      previewThumbnails: { enabled: false, src: "" },
      seek: true,
    });

    player.on("ready", function (event) {
      setTimeout(function () {
        $(
          "<div class='current-time'>" +
            format_player_time(player.currentTime, player.duration) +
            "</div>"
        ).insertAfter($(event.target).find(".plyr__progress__container"));
      }, 2000);

      if (navigator.userAgent.match("CriOS")) {
        element.addClass("is-chrome-ios");
      }

      if ($(".hero .plyr").length) {
        if ($(".hero .plyr").height() > $(window).height()) {
          $(".hero .plyr .plyr__controls").addClass("fixed-position");
        }
      }
    });

    player.on("timeupdate", function (event) {
      $(event.target)
        .find(".current-time")
        .empty()
        .text(format_player_time(player.currentTime, player.duration));
    });

    player.on("enterfullscreen", function (event) {
      $(event.target).addClass("fullscreen");

      site_header.hide();
    });

    player.on("exitfullscreen", function (event) {
      $(event.target).removeClass("fullscreen");

      site_header.show();
    });
  });

  $(".audio").each(function () {
    var player = new Plyr($(this), {
      controls: ["play-large", "play", "progress", "mute"],
      clickToPlay: true,
      volume: 1,
      seek: true,
    });

    player.on("ready", function (event) {
      if ($(".hero").hasClass("type-audio")) {
        var captions_btn = $(
          '<button class="plyr__controls__item plyr__control plyr__tab-focus plyr__control--pressed" type="button" data-plyr="captions"></button>'
        );
        captions_btn.insertBefore($(".hero .plyr .plyr__volume"));

        captions_btn.click(function () {
          var content = $(".article-page .row-block").first().offset();

          $("html, body").animate(
            {
              scrollTop: content.top,
            },
            500
          );

          return false;
        });
      }

      setTimeout(function () {
        $(
          "<div class='current-time'>" +
            format_player_time(player.currentTime, player.duration) +
            "</div>"
        ).insertAfter($(event.target).find(".plyr__progress__container"));
      }, 2000);
    });

    player.on("timeupdate", function (event) {
      $(event.target)
        .find(".current-time")
        .empty()
        .text(format_player_time(player.currentTime, player.duration));
    });
  });

  if ($(".hero.type_audio video").length) {
    $(".hero.type_audio video")[0].play();
  }

  Number.prototype.pad = function (size) {
    var s = String(this);
    while (s.length < (size || 2)) {
      s = "0" + s;
    }
    return s;
  };

  function format_player_time(current_s, total_s) {
    var current_sec_num = parseInt(current_s, 10); // don't forget the second param
    var current_hours = Math.floor(current_sec_num / 3600);
    var current_minutes = Math.floor(
      (current_sec_num - current_hours * 3600) / 60
    );
    var current_seconds =
      current_sec_num - current_hours * 3600 - current_minutes * 60;

    var total_sec_num = parseInt(total_s, 10); // don't forget the second param
    var total_hours = Math.floor(total_sec_num / 3600);
    var total_minutes = Math.floor((total_sec_num - total_hours * 3600) / 60);
    var total_seconds = total_sec_num - total_hours * 3600 - total_minutes * 60;

    if (current_hours < 10) {
      current_hours = current_hours;
    }
    if (current_minutes < 10) {
      current_minutes = current_minutes;
    }
    if (current_seconds < 10) {
      current_seconds = current_seconds;
    }

    if (total_s >= 3600) {
      return (
        current_hours.pad(2) +
        ":" +
        current_minutes.pad(2) +
        ":" +
        current_seconds.pad(2) +
        " / " +
        total_hours.pad(2) +
        ":" +
        total_minutes.pad(2) +
        ":" +
        total_seconds.pad(2)
      );
    } else {
      return (
        current_minutes.pad(2) +
        ":" +
        current_seconds.pad(2) +
        " / " +
        total_minutes.pad(2) +
        ":" +
        total_seconds.pad(2)
      );
    }
  }

  //HEADER FUNCTIONALITY
  var site_header = $(".site-header");

  $(".nav-1 ul li a, .nav-2 ul li a").mouseenter(function () {
    var element = $(this);

    $(".nav-1 ul li a, .nav-2 ul li a").addClass("faded");

    element.removeClass("faded");
  });

  $(".nav-1 ul li a, .nav-2 ul li a").mouseleave(function () {
    $(".nav-1 ul li a, .nav-2 ul li a").removeClass("faded");
  });

  set_site_header_style();

  setTimeout(function () {
    site_header.show();
  }, 200);

  var fast_fade = true;
  function set_site_header_style() {
    if ($(".hero").hasClass("type-news_article")) {
      site_header.removeClass("transparent");
      site_header.addClass("white");
    }

    if (site_header.hasClass("home-style")) {
      if (scroll_top > 1) {
        if (site_header.hasClass("home-style-active")) {
          fast_fade = true;
        }

        site_header.removeClass("home-style-active");
      } else {
        if (!site_header.hasClass("home-style-active")) {
          fast_fade = true;
        }

        site_header.addClass("home-style-active");
      }

      if (fast_fade == true) {
        fast_fade = false;
        var home_link = site_header.find(".home");
        var home_link_clone = home_link.clone();

        home_link_clone.insertBefore(home_link);
        home_link.remove();
      }
    }

    if (site_header.hasClass("medium-style")) {
      if (scroll_top > 1) {
        if (site_header.hasClass("medium-style-active")) {
          fast_fade = true;
        }

        site_header.removeClass("medium-style-active");
      } else {
        if (!site_header.hasClass("medium-style-active")) {
          fast_fade = true;
        }

        site_header.addClass("medium-style-active");
      }

      if (fast_fade == true) {
        fast_fade = false;
        var home_link = site_header.find(".home");
        var home_link_clone = home_link.clone();

        home_link_clone.insertBefore(home_link);
        home_link.remove();
      }
    }

    if (site_header.hasClass("change-to-white")) {
      if ($(".hero").is(".type-featured_article")) {
        if (scroll_top > $(".hero-wrapper").height() / 2) {
          site_header.addClass("white");
        } else {
          site_header.removeClass("white");
        }
      } else if ($(".hero").is(".type-topic")) {
        if (
          scroll_top >
          $(".hero-wrapper").height() / 2 -
            $(".hero-content").height() / 2 -
            site_header.height() / 2
        ) {
          site_header.addClass("white");
        } else {
          site_header.removeClass("white");
        }
      } else {
        if (scroll_top > $(".hero-wrapper").height()) {
          site_header.addClass("white");
        } else {
          site_header.removeClass("white");
        }
      }
    }

    if (site_header.hasClass("change-to-black")) {
      if (scroll_top > 1) {
        site_header.addClass("black");
      } else {
        site_header.removeClass("black");
      }
    }

    if ($(".block-banner-sphere").length > 0) {
      var el = $(".block-banner-sphere")[0];
      var rect = el.getBoundingClientRect();
      var elemTop = rect.top;
      var elemBottom = rect.bottom;

      if (elemTop < 0 && elemBottom > 0) {
        site_header.addClass("green");
      } else {
        site_header.removeClass("green");
      }
    }

    // if(site_header.hasClass('change-to-black')) {
    //   if(scroll_top > 1) {
    //     site_header.removeClass('transparent white');
    //   }
    //   else {
    //     site_header.addClass('transparent white');
    //   }
    // }
    // else if(site_header.hasClass('transparent')) {
    //   if(scroll_top > $('.hero-wrapper').height()) {
    //     site_header.addClass('white');
    //   }
    //   else {
    //     site_header.removeClass('white');
    //   }
    // }
    // else if(site_header.hasClass('black')) {
    //
    // }
  }

  //ARTICLE PAGE
  $(".text-size-toggle .less, .text-size-toggle .more").click(function () {
    var btn_less = $(".text-size-toggle .less");
    var btn_more = $(".text-size-toggle .more");
    var btn_clicked = $(this);

    if (btn_clicked.is(btn_less)) {
      $(".article-header").removeClass("large-text");
      $(".row-block").removeClass("large-text");
      btn_less.addClass("active");
      btn_more.removeClass("active");
    } else if (btn_clicked.is(btn_more)) {
      $(".article-header").addClass("large-text");
      $(".row-block").addClass("large-text");
      btn_less.removeClass("active");
      btn_more.addClass("active");
    }

    return false;
  });

  //BACK TO TOP
  $(".back-to-top").click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      300
    );

    return false;
  });

  //ARTICLE PAGE FIX FOR EMPTY PARAGRAPHS
  $(".article-page p, .general-page .page-content .purpose-text p").filter(
    function () {
      var element = $(this);
      if ($.trim(element.html()) == "&nbsp;") {
        element.addClass("h2");
      }
    }
  );

  $(".article-page p, .general-page .page-content .content p").filter(
    function () {
      var element = $(this);
      if ($.trim(element.html()) == "&nbsp;") {
        element.addClass("h6");
      }
    }
  );

  //VOLUME PAGE FUNCTIONALITY
  $(".volume-page-wrapper").scroll(function () {
    if (site_header.hasClass("medium-style")) {
      if ($(".volume-page-wrapper").scrollTop() > 1) {
        site_header.removeClass("medium-style-active");
      } else {
        site_header.addClass("medium-style-active");
      }
    }
  });

  if ($(".volume-intro").length) {
    $("html, body").scrollTop(0);

    setTimeout(function () {
      $(".volume-intro").fadeOut();
    }, 2000);

    //MOBILE BACK BUTTON FIX
    $(".volume-article-background").removeClass("visible");
    site_header.addClass("white");
    $(".volume-page").removeClass("invert");

    $(".volume-article-background").appendTo("body");
  }

  var change_header_timeout;
  $(".volume-navigation .volume-article-background video").attr("preload", "");
  $(
    ".main-article:not(.has-sub-articles):not(.coming-soon), .sub-article:not(.coming-soon)"
  ).mouseenter(function () {
    clearTimeout(change_header_timeout);
    var element = $(this);

    if (
      $(
        '.volume-article-background[data-article="' +
          element.attr("data-article") +
          '"]'
      ).length
    ) {
      if (
        $(
          '.volume-article-background[data-article="' +
            element.attr("data-article") +
            '"]'
        ).find("video").length
      ) {
        $(
          '.volume-article-background[data-article="' +
            element.attr("data-article") +
            '"]'
        )
          .find("video")[0]
          .play();
      }

      $(
        '.volume-article-background[data-article="' +
          element.attr("data-article") +
          '"]'
      ).addClass("visible");

      site_header.removeClass("white");
      $(".volume-page").addClass("invert");
    }
  });

  $(
    ".main-article:not(.has-sub-articles):not(.coming-soon), .sub-article:not(.coming-soon)"
  ).mouseleave(function () {
    var element = $(this);

    if (
      $(
        '.volume-article-background[data-article="' +
          element.attr("data-article") +
          '"]'
      ).find("video").length
    ) {
      $(
        '.volume-article-background[data-article="' +
          element.attr("data-article") +
          '"]'
      )
        .find("video")[0]
        .pause();
    }

    $(
      '.volume-article-background[data-article="' +
        element.attr("data-article") +
        '"]'
    ).removeClass("visible");

    change_header_timeout = setTimeout(function () {
      site_header.addClass("white");
      $(".volume-page").removeClass("invert");
    }, 100);
  });

  $(
    ".main-article:not(.has-sub-articles):not(.coming-soon), .sub-article:not(.coming-soon)"
  ).on("click", function () {
    if (hasTouch()) {
      var element = $(this);
      var url = element.attr("href");

      if (
        $(
          '.volume-article-background[data-article="' +
            element.attr("data-article") +
            '"]'
        ).length
      ) {
        $(
          '.volume-article-background[data-article="' +
            element.attr("data-article") +
            '"]'
        ).addClass("visible");

        site_header.removeClass("white");
        $(".volume-page").addClass("invert");
      }

      setTimeout(function () {
        window.location.href = url;
      }, 2000);

      // if(!element.hasClass('coming-soon')) {
      //   setTimeout(function() {
      //     $('.volume-article-background[data-article="' + element.attr('data-article') + '"]').removeClass('visible');
      //
      //     site_header.addClass('white');
      //     $('.volume-page').removeClass('invert');
      //
      //     setTimeout(function() {
      //       window.location.href = url;
      //     }, 400);
      //   }, 1400);
      // }

      return false;
    }
  });

  //SLIDESHOWS
  var slideshows = new Array();
  var swiper_init_retries = 40;
  start_slideshows_when_ready();

  function start_slideshows_when_ready() {
    if (typeof Swiper === "undefined") {
      if (swiper_init_retries > 0) {
        swiper_init_retries -= 1;
        setTimeout(start_slideshows_when_ready, 50);
      }
      return;
    }

    start_slideshows();
  }
  function start_slideshows() {
    if (slideshows.length > 0) {
      for (var i = 0; i < slideshows.length; i++) {
        slideshows[i].destroy();
      }

      slideshows = new Array();
    }

    $(".swiper-container").each(function () {
      var swiper_container = $(this);

      if (
        swiper_container.is(".menu-volumes-slideshow") &&
        $(window).width() <= s_min
      ) {
        swiper_container.removeClass("swiper-container-initialized");
        swiper_container.find(".swiper-wrapper").attr("style", "");
        swiper_container.find(".swiper-slide").attr("style", "");
        return true;
      }

      var options = {
        simulateTouch: false,
        slidesPerView: "auto",
        spaceBetween: 0,
        speed: 600,
        navigation: {
          nextEl: swiper_container.find(".swiper-button-next"),
          prevEl: swiper_container.find(".swiper-button-prev"),
        },
        // watchSlidesVisibility: true,
        freeMode: true,
        breakpoints: {
          1024: {
            freeMode: false,
          },
        },
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 6,
        },
        centeredSlides: true,
        centeredSlidesBounds: true,
      };

      if (
        swiper_container.is(".articles-slideshow") ||
        swiper_container.is(".shop-slideshow")
      ) {
      } else if (swiper_container.is(".article-slideshow")) {
        options = {
          simulateTouch: false,
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 600,
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          navigation: {
            nextEl: swiper_container.find(".swiper-button-next"),
            prevEl: swiper_container.find(".swiper-button-prev"),
          },
          pagination: {
            el: swiper_container.find(".pagination"),
            type: "custom",
            renderCustom: function (swiper, current, total) {
              return "Image " + current + " of " + total;
            },
          },
          loop: true,
          watchSlidesProgress: true,
          preloadImages: false,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 3,
          },
          // watchSlidesVisibility: true,
        };
      } else if (swiper_container.is(".hero-slideshow")) {
        if ($(window).width() > m_min) {
          options = {
            simulateTouch: false,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 600,
            navigation: {
              nextEl: swiper_container.find(".swiper-button-next"),
              prevEl: swiper_container.find(".swiper-button-prev"),
            },
            pagination: {
              el: $(".block-slideshow-details .pagination"),
              type: "custom",
              renderCustom: function (swiper, current, total) {
                return "Image " + current + " of " + total;
              },
            },
            loop: true,
            effect: "fade",
            fadeEffect: {
              crossFade: true,
            },
            preloadImages: false,
            lazy: {
              loadPrevNext: true,
              loadPrevNextAmount: 3,
            },
            // watchSlidesVisibility: true,
          };
        } else {
          options = {
            simulateTouch: false,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 600,
            navigation: {
              nextEl: swiper_container.find(".swiper-button-next"),
              prevEl: swiper_container.find(".swiper-button-prev"),
            },
            pagination: {
              el: $(".block-slideshow-details .pagination"),
              type: "custom",
              renderCustom: function (swiper, current, total) {
                return "Image " + current + " of " + total;
              },
            },
            loop: true,
            preloadImages: false,
            lazy: {
              loadPrevNext: true,
              loadPrevNextAmount: 4,
            },
            // watchSlidesVisibility: true,
          };
        }
      } else if (swiper_container.is(".product-slideshow")) {
        options = {
          simulateTouch: false,
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 600,
          navigation: {
            nextEl: swiper_container.find(".swiper-button-next"),
            prevEl: swiper_container.find(".swiper-button-prev"),
          },
          loop: true,
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          preloadImages: false,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
          },
          // watchSlidesVisibility: true,
        };
      } else if (swiper_container.is(".menu-volumes-slideshow")) {
        options = {
          slidesPerView: "auto",
          autoHeight: false,
          spaceBetween: 0,
          mousewheel: true,
          freeMode: true,
        };
      }

      var swiper = new Swiper(swiper_container, options);
      slideshows.push(swiper);

      if (
        swiper_container.is(".articles-slideshow") ||
        swiper_container.is(".shop-slideshow")
      ) {
        if ($(window).width() <= s_min) {
          swiper.destroy();
          swiper_container.find(".swiper-slide").removeClass("blurred");
        }
        // else {
        //   swiper.destroy();
        //
        //   swiper_container.attr('data-translate-x', 0);
        //
        //   var total_width = 0;
        //
        //   swiper_container.find('.swiper-slide').each(function() {
        //     var slide = $(this);
        //     total_width = total_width + slide.width();
        //   });
        //
        //   swiper_container.find('.swiper-button-next').click(function() {
        //     var swiper_wrapper = swiper_container.find('.swiper-wrapper');
        //     var calc = parseInt(swiper_container.attr('data-translate-x')) - (total_width + (30 * swiper_container.find('.swiper-slide').length + 1))/3;
        //
        //     // if(calc == 0) {
        //     //   transform_calc = 'calc(0)';
        //     // }
        //
        //     swiper_wrapper.css('transform', 'translateX(' + calc + 'px)');
        //
        //     swiper_container.attr('data-translate-x', calc);
        //
        //     return false;
        //   });
        //
        //   swiper_container.find('.swiper-button-prev').click(function() {
        //     var swiper_wrapper = swiper_container.find('.swiper-wrapper');
        //     var calc = parseInt(swiper_container.attr('data-translate-x')) + 33;
        //
        //     var transform_calc = 'calc(' + calc + '%)';
        //
        //     // if(calc == 0) {
        //     //   transform_calc = 'calc(0)';
        //     // }
        //
        //     swiper_wrapper.css('transform', 'translateX(' + transform_calc + ')');
        //
        //     swiper_container.attr('data-translate-x', calc);
        //
        //     return false;
        //   });
        // }

        function checkSlidesOffscreen(swiper_container) {
          swiper_container.find(".swiper-slide").each(function () {
            var element = $(this);

            // if(element.prevAll().filter($('.swiper-slide-active')).length !== 0) {
            if (
              !isScrolledIntoViewHorizontal(
                element[0],
                $(element[0]).width() / 2,
                "complete"
              )
            ) {
              element.addClass("blurred");
            } else {
              element.removeClass("blurred");
            }
            // }
            // else {
            //   element.removeClass('blurred');
            // }
          });
        }
        checkSlidesOffscreen(swiper_container);

        if ($(window).width() < s_min) {
          swiper_container.find(".swiper-slide").removeClass("blurred");
        }

        if (swiper && swiper.destroyed != true) {
          swiper.on("slideChange transitionEnd init update", function (e) {
            checkSlidesOffscreen(swiper_container);
          });

          swiper.on("slideChange", function () {
            var total_slides = swiper_container.find(
              ".swiper-slide:not(.swiper-slide-duplicate)"
            ).length;
            var current_index = swiper.realIndex + 1;

            if (current_index == total_slides - 1) {
              swiper_container.find(".swiper-button-next").hide();
            } else {
              swiper_container.find(".swiper-button-next").show();
            }
          });
        }
      } else if (swiper_container.is(".article-slideshow")) {
      } else if (swiper_container.is(".hero-slideshow")) {
        $(
          ".slideshow-thumbnails .thumbnail, .slideshow-thumbnails .return-to-title-slide, .hero-slideshow .thumbnail"
        )
          .unbind("click")
          .click(function () {
            var index = $(this).attr("data-index");

            if ($(window).width() <= m_min) {
              swiper.slideTo(index - 1, 0);
            } else {
              swiper.slideTo(index, 0);
            }

            if ($(".slideshow-thumbnails").hasClass("is-lightbox")) {
              $("html").removeClass("overflow-hidden");
              $("html, body").scrollTop(0);
              $(".slideshow-thumbnails").removeClass("open");
            }

            return false;
          });

        $(".block-slideshow-details .thumbnail-view")
          .unbind("click")
          .click(function () {
            if ($(".slideshow-thumbnails").hasClass("is-lightbox")) {
              $(".slideshow-thumbnails").addClass("open");
              $("html").addClass("overflow-hidden");
            } else {
              var thumbnails_offset = $(".slideshow-thumbnails").offset();

              $("html, body").animate(
                {
                  scrollTop: thumbnails_offset.top - 50,
                },
                300
              );
            }

            return false;
          });

        $(".slideshow-thumbnails .close")
          .unbind("click")
          .click(function () {
            $("html").removeClass("overflow-hidden");
            $(".slideshow-thumbnails").removeClass("open");

            return false;
          });

        //CHANGE CAPTION ON INIT
        var caption = (caption = swiper_container
          .find(".swiper-slide.swiper-slide-active figcaption")
          .html());
        if (
          swiper_container.find(".swiper-slide[data-swiper-slide-index]").length
        ) {
          caption = swiper_container
            .find(
              '.swiper-slide:not(.swiper-slide-duplicate)[data-swiper-slide-index="' +
                swiper.realIndex +
                '"] figcaption'
            )
            .html();
        } else {
          caption = swiper_container
            .find(".swiper-slide.swiper-slide-active figcaption")
            .html();
        }

        $(".block-slideshow-details .slide-caption").empty().html(caption);

        swiper.on("slideChange", function (e) {
          // $('html, body').animate({
          //   scrollTop: 0
          // }, 300);\

          $("html, body").scrollTop(0);

          if (swiper_container.hasClass("thumbnail-grid-visible")) {
            if (swiper.realIndex == 0) {
              setTimeout(function () {
                $(".article-header").fadeIn(200);
                $(".slideshow-thumbnails .row-top").fadeOut(200);
              }, 350);
            } else {
              setTimeout(function () {
                $(".article-header").fadeOut(200);
                $(".slideshow-thumbnails .row-top").fadeIn(200);
              }, 350);
            }
          }

          //CHANGE CAPTION ON CHANGE
          // var caption = swiper_container.find('.swiper-slide:not(.swiper-slide-duplicate)[data-swiper-slide-index="' + swiper.realIndex + '"] figcaption').text();
          var caption = "";
          if (
            swiper_container.find(".swiper-slide[data-swiper-slide-index]")
              .length
          ) {
            caption = swiper_container
              .find(
                '.swiper-slide:not(.swiper-slide-duplicate)[data-swiper-slide-index="' +
                  swiper.realIndex +
                  '"] figcaption'
              )
              .html();
          } else {
            caption = swiper_container
              .find(
                ".swiper-slide:nth-child(" +
                  (swiper.realIndex + 1) +
                  ") figcaption"
              )
              .html();
          }

          $(".block-slideshow-details .slide-caption").empty().html(caption);
        });
      }

      if (swiper_container.find(".progress").length) {
        swiper.on("update transitionStart", function (e) {
          var total_slides = swiper_container.find(
            ".swiper-slide:not(.swiper-slide-duplicate)"
          ).length;
          var current_index = swiper.realIndex + 1;

          var fraction = current_index / total_slides;

          swiper_container
            .find(".progress .fill")
            .css("width", 100 / total_slides + "%");
          swiper_container
            .find(".progress .fill")
            .css("left", fraction * 100 - 100 / total_slides + "%");
        });
      }

      //SHOP SPECIFIC
      // if (swiper_container.is('.product-slideshow')) {
      // 	if (swiper_container[0].swiper.slides.length - 2 == 1) {
      // 		swiper_container.find('.swiper-button-prev').remove();
      // 		swiper_container.find('.swiper-button-next').remove();
      // 	}
      // }

      if (
        $(".single-option-selector").length &&
        $(".product-page").is(".has-variants")
      ) {
        var value = $(".single-option-selector").val();
        var swiper_element = $(".product-slideshow");
        var slide_index = $(
          swiper_element.find('[data-variant="' + value + '"]')[0]
        ).index();

        swiper_element[0].swiper.slideTo(slide_index);

        $(".single-option-selector").change(function () {
          var value = $(this).val();
          var swiper_element = $(".product-slideshow");
          var slide_index = $(
            swiper_element.find('[data-variant="' + value + '"]')[0]
          ).index();

          swiper_element[0].swiper.slideTo(slide_index);
        });
      }
    });
  }

  //GRID LIMITS
  $(".articles-grid .collapse, .sphere-grid .collapse").each(function () {
    var collapse = $(this);
    var grid = collapse.parent();

    collapse.css("height", collapse.height() / 3);

    grid.addClass("grid-collapsed");
  });

  $(".separator .expand, .grid-collapsed .collapse").click(function () {
    var element_clicked = $(this);

    if (element_clicked.is(".collapse") && $(window).width() < m_min) {
      //DO NOTHING
    } else {
      var grid = element_clicked.parents(".grid-collapsed");
      grid.find(".collapse .separator").remove();
      grid.find(".collapse > div").unwrap();
      grid.removeClass("grid-collapsed");

      return false;
    }
  });

  $(".topics-wrapper .expand").click(function () {
    $(this).parent(".topics-wrapper").addClass("expanded");

    return false;
  });

  //SPHERE FILTERS
  $(".block-sphere-filters .topic-wrapper").click(function () {
    $(".grid-collapsed .expand").click();

    var element = $(this);
    var slug = element.attr("data-slug");

    if (element.hasClass("clicked")) {
      element.removeClass("clicked");

      $(".block-sphere-elements .sphere-grid > div").show();

      window.history.pushState("", "", window.location.pathname);
    } else {
      $(".block-sphere-filters .topic-wrapper").removeClass("clicked");
      element.addClass("clicked");

      $(".block-sphere-elements .sphere-grid > div").hide();
      $(".block-sphere-elements .sphere-grid > div ." + slug)
        .parent("div")
        .show();

      window.history.pushState("", "", window.location.pathname);
      // window.history.pushState("","", window.location.pathname + "?filter=" + slug);
    }

    return false;
  });

  //SOCIAL SHARE
  var clipboard = new ClipboardJS(".copylink");

  var link_copied_timeout;
  clipboard.on("success", function (e) {
    $(".link-copied").remove();
    clearTimeout(link_copied_timeout);

    $("body").append(
      '<span class="link-copied" style="display: none;">Link copied to clipboard</span>'
    );

    $(".link-copied").fadeIn(200);

    link_copied_timeout = setTimeout(function () {
      $(".link-copied").fadeOut(300, function () {
        $(".link-copied").remove();
      });
    }, 1800);

    e.clearSelection();
  });

  $(".social-share .link").mouseenter(function () {
    var element = $(this);

    $(".social-share .link").addClass("faded");

    element.removeClass("faded");
  });

  $(".social-share .link").mouseleave(function () {
    $(".social-share .link").removeClass("faded");
  });

  $(".social-share .facebook, .social-share .twitter").click(function (e) {
    var _href = $(this).attr("href");
    e.preventDefault();
    var facebookWindow = window.open(
      _href,
      "facebook-popup",
      "height=350, width=450, top=" +
        ($(window).height() / 2 - 175) +
        ", left=" +
        ($(window).width() / 2 - 225) +
        ", toolbar=0, location=0, menubar=0, directories=0, scrollbars=0"
    );
    if (facebookWindow.focus) {
      facebookWindow.focus();
    }
  });

  if ($(".hero .plyr").length) {
    $(".hero .plyr").css("height", $(".hero").outerHeight() + "px");
  }

  //PAGE EVENTS
  var last_window_width = $(window).width();
  $(window).resize(function () {
    if ($(".hero .plyr").length) {
      if ($(".hero .plyr").height() > $(window).height()) {
        $(".hero .plyr .plyr__controls").addClass("fixed-position");
      } else {
        $(".hero .plyr .plyr__controls").removeClass("fixed-position");
      }
    }

    if ($(window).width() > m_min) {
      var vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", vh + "px");
    }

    if ($(window).width() != last_window_width) {
      close_drawer();

      start_slideshows();

      // if($('.grid-collapsed .collapse').length) {
      //   $('.grid-collapsed .expand').click();
      // }
    }

    if ($(".hero .plyr").length) {
      $(".hero .plyr").css("height", $(".hero").outerHeight() + "px");
    }

    last_window_width = $(window).width();
  });

  var lastScrollTop = 0;
  var scroll_top = $(window).scrollTop();
  $(window).scroll(function () {
    scroll_top = $(window).scrollTop();

    //HEADER
    set_site_header_style();

    //HERO
    if ($(".hero-bg").length) {
      if (scroll_top > $(".hero-wrapper").height() + 100) {
        $(".hero-bg").hide();
      } else {
        $(".hero-bg").show();
      }
    }

    //BACK TO TOP
    if ($(".back-to-top").length) {
      // if(scroll_top > $(window).height() + 200) {
      //   $('.back-to-top').fadeIn(200);
      // }
      // else {
      //   $('.back-to-top').fadeOut(200);
      // }

      var offset = 80;
      if ($(window).width() < s_min) {
        offset = 40;
      } else if ($(window).width() < m_min) {
        offset = 40;
      } else if ($(window).width() < l_min) {
        offset = 50;
      }

      if ($(".background-black").length) {
        // if(isScrolledIntoView($('.site-footer')[0], offset, 'partial') || isScrolledIntoView($('.background-black')[0], offset, 'partial')) {
        //   $('.back-to-top').addClass('white');
        // }
        // else {
        //   $('.back-to-top').removeClass('white');
        // }
      } else {
        // if(isScrolledIntoView($('.site-footer')[0], offset, 'partial')) {
        //   $('.back-to-top').addClass('white');
        // }
        // else {
        //   $('.back-to-top').removeClass('white');
        // }
      }
    }

    //TICKER
    if ($(".ticker").length) {
      clearInterval(ticker_interval);
      ticker_interval = false;
      clearTimeout(ticker_timeout);

      ticker_timeout = setTimeout(function () {
        if (isScrolledIntoView($(".ticker")[0], 0, "partial")) {
          if (ticker_interval == false) {
            start_ticker();
          }
        } else {
          clearInterval(ticker_interval);
          ticker_interval = false;
        }
      }, 1000);
    }

    //NEWSLETTER POPUP
    if ($(".newsletter-popup").length) {
      if (scroll_top > $(document).height() / 2) {
        $(".newsletter-popup").fadeIn(300);
      }
    }

    //SOCIAL SHARE
    if ($(".social-share").length) {
      if (scroll_top > $(window).height()) {
        $(".social-share").addClass("visible");
      } else {
        $(".social-share").removeClass("visible");
      }
    }

    //ARTICLE PAGE
    if ($(".article-page").length) {
      if (scroll_top > lastScrollTop) {
        //down
        if (scroll_top > 5) {
          //down
          site_header.addClass("offscreen");
        }
      } else {
        //up
        site_header.removeClass("offscreen");
      }

      $(".side-note").each(function () {
        var element = $(this);
        if (isScrolledIntoView(element[0], $(window).height() / 2, "partial")) {
          element.addClass("visible");
        }
      });
    }

    lastScrollTop = scroll_top;
  });

  //FOOTER
  // $('.site-footer ul li a').mouseenter(function () {
  // 	var element = $(this);

  // 	$('.site-footer ul li a').addClass('faded');

  // 	element.removeClass('faded');
  // });

  // $('.site-footer ul li a').mouseleave(function () {
  // 	$('.site-footer ul li a').removeClass('faded');
  // });

  $(document).keyup(function (e) {
    if (e.keyCode == "27") {
      close_drawer();
      $(".slideshow-thumbnails.is-lightbox").removeClass("open");
      $("html").removeClass("overflow-hidden");
    }
  });

  //HELPERS
  function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(
      /^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i
    );
    return pattern.test(emailAddress);
  }

  function isScrolledIntoView(el, offset, area) {
    if (!offset) {
      offset = 0;
    }

    if (!area) {
      area = "complete";
    }

    var rect = el.getBoundingClientRect();
    var elemTop = rect.top + offset;
    var elemBottom = rect.bottom + offset;

    // elemBottom = elemTop;

    var isVisible = false;

    if (area == "complete") {
      // Only completely visible elements return true:
      isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
    } else if ((area == "partial", offset, area)) {
      // Partially visible elements return true:
      isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    }

    return isVisible;
  }

  function isScrolledIntoViewHorizontal(el, offset, area) {
    if (!offset) {
      offset = 0;
    }

    if (!area) {
      area = "complete";
    }

    var rect = el.getBoundingClientRect();
    var elemLeft = rect.left + offset;
    var elemRight = rect.right;

    var isVisible = false;

    if (area == "complete") {
      // Only completely visible elements return true:
      isVisible = elemLeft >= 0 && elemRight <= window.innerWidth;
    } else if (area == "partial") {
      // Partially visible elements return true:
      isVisible =
        elemLeft < window.innerWidth && elemRight >= 0 && elemLeft >= 0;
    }

    return isVisible;
  }

  function hasTouch() {
    return (
      "ontouchstart" in document.documentElement ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }

  if (hasTouch()) {
    // remove all :hover stylesheets
    try {
      // prevent exception on browsers not supporting DOM styleSheets properly
      for (var si in document.styleSheets) {
        var styleSheet = document.styleSheets[si];
        if (!styleSheet.rules) continue;

        for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
          if (!styleSheet.rules[ri].selectorText) continue;

          if (styleSheet.rules[ri].selectorText.match(":hover")) {
            styleSheet.deleteRule(ri);
          }
        }
      }
    } catch (ex) {}
  }

  // The MIT License (MIT) Copyright © 2019 Agilie Team https://www.agilie.com/

  (function webpackUniversalModuleDefinition(root, factory) {
    if (typeof exports === "object" && typeof module === "object")
      module.exports = factory();
    else if (typeof define === "function" && define.amd) define([], factory);
    else if (typeof exports === "object") exports["getCoverSize"] = factory();
    else {
      root["canvasImageCoverPosition"] = root["getCoverSize"] = factory();
    }
  })(window, function () {
    return function (
      contentWidth,
      contentHeight,
      containerWidth,
      containerHeight,
      offsetLeft,
      offsetTop
    ) {
      var contentRatio = contentWidth / contentHeight;
      var containerRatio = containerWidth / containerHeight;
      var resultHeight;
      var resultWidth;
      offsetLeft = typeof offsetLeft === "undefined" ? 0.5 : offsetLeft;
      offsetTop = typeof offsetTop === "undefined" ? 0.5 : offsetTop;
      if (contentRatio > containerRatio) {
        resultHeight = containerHeight;
        resultWidth = containerHeight * contentRatio;
      } else {
        resultWidth = containerWidth;
        resultHeight = containerWidth / contentRatio;
      }
      return {
        width: resultWidth,
        height: resultHeight,
        offsetLeft: (containerWidth - resultWidth) * offsetLeft,
        offsetTop: (containerHeight - resultHeight) * offsetTop,
      };
    };
  });

  // create_blurry_backgrounds();
  // function create_blurry_backgrounds() {
  //   var containers = $('.blurred-img-wrapper');
  //
  //   containers.each(function() {
  //     var container = $(this);
  //
  //     var canvas = document.createElement('canvas');
  //     var ctx = canvas.getContext('2d');
  //
  //     canvas.width = container.width();
  //     canvas.height = container.height();
  //
  //     container[0].appendChild(canvas)
  //
  //     var image = new Image;
  //     image.onload = function() {
  //       var imageCoverSize = getCoverSize(
  //           image.naturalWidth,
  //           image.naturalHeight,
  //           canvas.width,
  //           canvas.height,
  //           0.5,
  //           0.5
  //       );
  //
  //       ctx.filter = 'blur(10px)';
  //       ctx.drawImage(image, imageCoverSize.offsetLeft, imageCoverSize.offsetTop, imageCoverSize.width, imageCoverSize.height);
  //
  //       $(canvas).addClass('loaded');
  //     }
  //     image.src = container.attr('data-image-to-blur');
  //   });
  // }

  if ($(".initials").length) {
    $(".initials").each(function () {
      var str = $(this).attr("data-words");
      var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
      var acronym = matches.join(""); // JSON

      $(this)
        .empty()
        .append("<span>" + acronym + "</span>");
    });
  }

  //NEWSLETTER PAGE
  // $('.newsletter-form').submit(function() {
  //   var to_return = true;
  //   var form = $(this);
  //   var email_input = form.find('input[type="text"]');
  //   var email_val = email_input.val();
  //
  //   if(isValidEmailAddress(email_val) == false) {
  //     email_input.parent('.input-wrapper').addClass('invalid');
  //     return false;
  //   }
  //   else {
  //     email_input.parent('.input-wrapper').removeClass('mce_inline_error');
  //     return true;
  //   }
  // });

  $(".input-wrapper .clear").click(function () {
    var input = $(this).parent(".input-wrapper").find("input");
    input.removeClass("mce_inline_error");
    input.val("");

    $(".mce_inline_error").empty().hide();

    return false;
  });

  $(".newsletter-form input").on("change", function () {
    $(this).removeClass("mce_inline_error");
  });

  if ($(".newsletter-page").length) {
    $(".newsletter-page .topics-list").addClass("topics-wrapper");

    $(".newsletter-page .topics-list > label span").each(function () {
      $(this).addClass("topic medium white");
    });

    if ($(".newsletter-page .mc4wp-response").children().length > 0) {
      $(".mc4wp-response").insertBefore(".mc4wp-form-fields").show();
    } else {
      $(".newsletter-message").show();
    }
  }

  if ($(".newsletter-popup").length) {
    $(".newsletter-popup .close").click(function () {
      $(".newsletter-popup").fadeOut(300, function () {
        var newsletter_form = $(
          $(".newsletter-popup").find(".newsletter-form-wrapper").html()
        );

        $(".site-footer")
          .find(".footer-section .newsletter-form-wrapper")
          .empty()
          .append(newsletter_form);

        newsletter_form.find(".input-wrapper .clear").click(function () {
          var input = $(this).parent(".input-wrapper").find("input");
          input.removeClass("mce_inline_error");
          input.val("");

          $(".mce_inline_error").empty().hide();

          return false;
        });

        newsletter_form
          .find(".newsletter-form input")
          .on("change", function () {
            $(this).removeClass("mce_inline_error");
          });

        $(".newsletter-popup").remove();
      });

      return false;
    });
  }

  //SHOP SPECIFIC
  $("#ReCharge-Payment-Method").cleanWhitespace();

  if ($(".product__details").length) {
    $(".product__details").insertBefore($("#shopify-section-footer"));
    $(".product__details").wrap("<div class='product__details_wrapper'></div>");
  }

  $("body.template-product").scroll(function () {
    if ($(window).width() < s_min) {
      position_product_details();
    }
  });

  $(window).scroll(function () {
    if ($(window).width() >= s_min) {
      position_product_details();
    }
  });

  function position_product_details() {
    if ($(".product__details").length) {
      if (isScrolledIntoView($(".site-footer")[0], 0, "partial")) {
        $(".product__details_wrapper").css("height", "auto");
        $(".product__details").css("position", "static");
      } else {
        $(".product__details_wrapper").css(
          "height",
          $(".product__details").height() + "px"
        );
        $(".product__details").css("position", "fixed");
      }
    }
  }
});
